import React, { Fragment, useEffect, useMemo, useState } from "react";
import "./index.scss";
import HeaderAction from "../components/HeaderAction";
import TitleLogo from "../components/TitleLogo";
import Reel from "../components/Reel";
import logoShwePuzzle from "../../../../assets/images/Mini-Game/logoShwePuzzle.png";
import logoShwePuzzleThadingyutTheme from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/logoShwePuzzle-thadingyut-2025-theme.png";
import logoShwePuzzleNewYear from "../../../../assets/images/Mini-Game/new-year-2025/new-year-title.png";
import { Link, useNavigate } from "react-router-dom";
import PATH from "../../../../config/PATH";
import { useDispatch, useSelector } from "react-redux";
import { curStateAccount, curStateMiniGame } from "../../../../Redux/selector";
import _ from "lodash";
import { useTranslation } from "react-i18next";
import ActionComponent from "../components/Action";
import MissionsList from "../components/MissionsList";
import ItemMission from "../components/MissionsList/ItemMission";
import bg1 from "../../../../assets/images/Mini-Game/bg-icon-mission.png";
import bg2 from "../../../../assets/images/Mini-Game/bg-icon-mission2.png";
import imgReelFooter from "../../../../assets/images/Mini-Game/img-reel-footer.png";
import imgReelFooterThadingyutTheme from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/img-reel-footer-thadingyut-2025-theme.png";
import imgReelFooterNewYear from "../../../../assets/images/Mini-Game/new-year-2025/1.png";
import {
  getDataMissionMiniGame,
  getDataSpinAwardMiniGame,
  setOpenPopupFooter,
  setOpenPopupLogin,
} from "../../../../Redux/futures/mini-game/action";
import ListPrizes from "./ListPrizes";
import CardChange from "../components/MissionCard/CardChange";
import {
  ID_TAB_MINI_GAME,
  useNewYear2025Theme,
  useThadingyutTheme,
} from "../../../../helper/const";
import EventMarquee from "../components/EventMarquee";
// import { IS_EVENT_THADINGYUT_2025_THEME } from "../../../../helper/const";
import lotusIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lotus-icon.png";
import lanternIcon from "../../../../assets/images/Mini-Game/thadingyut-2025-theme/lantern-icon.png";
import styled from "styled-components";
import footerTree from "../../../../assets/images/Mini-Game/new-year-2025/footer-tree.png";

export default function MiniGamePageHome() {
  const { t } = useTranslation();
  const dataMiniGame = useSelector(curStateMiniGame);
  const selectorAccount = useSelector(curStateAccount);
  const [bidTotal, setBidTotal] = useState(0);
  const [bid, setBid] = useState(1);
  const dataMissionMini = dataMiniGame.dataMissionMini || [];
  const navigate = useNavigate();
  const IS_EVENT_THADINGYUT_2025_THEME = useThadingyutTheme();
  const IS_EVENT_NEW_YEAR_2025_THEME = useNewYear2025Theme();

  useEffect(() => {
    setBid(dataMiniGame?.popupEarnMore?.turn || 1);
  }, [dataMiniGame?.popupEarnMore?.turn]);

  const {
    dailyMissions = [],
    standardMissions = [],
    missionDetail = [],
  } = useMemo(() => {
    if (_.isEmpty(dataMissionMini)) {
      return {};
    }
    let dailyMissions = dataMissionMini.filter(
      (item) => item.is_one_time_daily
    );

    let missionDetail = dataMissionMini.filter(
      (item) => !item.is_one_time_daily
    );
    const standardMissions = missionDetail;
    return { dailyMissions, standardMissions, missionDetail };
  }, [dataMissionMini]);

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDataSpinAwardMiniGame());
    dispatch(getDataMissionMiniGame());
  }, []);

  const showDataLogin = () => {
    dispatch(setOpenPopupLogin(true));
  };

  const handleTurnMini = () => {
    if (!selectorAccount.userInfo) {
      return showDataLogin();
    }
    dispatch(
      setOpenPopupFooter({
        isShowPopup: true,
        step: "change Coins",
        turn: bid,
      })
    );
  };

  useEffect(() => {
    if (selectorAccount.remainTurn) {
      const bidTotal = selectorAccount.remainTurn?.reduce((acc, pack) => {
        return acc + pack?.turn;
      }, 0);
      setBidTotal(bidTotal);
    }
  }, [selectorAccount.remainTurn]);

  const handleToBuyTurn = () => {
    navigate(PATH.PACKAGE);
  };

  const dataAwardList = useMemo(() => {
    if (_.isEmpty(dataMiniGame.dataAwardListMini)) {
      return [];
    }
    return dataMiniGame.dataAwardListMini.sort(
      (a, b) => Number(a.rank) - Number(b.rank)
    );
  }, [dataMiniGame.dataAwardListMini]);

  return (
    <div
      className={`container-minigame ${IS_EVENT_THADINGYUT_2025_THEME
        ? "thadingyut-theme"
        : IS_EVENT_NEW_YEAR_2025_THEME
          ? "new-year-25-theme"
          : ""
        }`}
    >
      <div className='minigame-home-header position-relative'>
        <EventMarquee />
        <HeaderAction />
        <TitleLogo
          className={`${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme-logo" : ""
            }`}
          logo={
            IS_EVENT_THADINGYUT_2025_THEME
              ? logoShwePuzzleThadingyutTheme
              : IS_EVENT_NEW_YEAR_2025_THEME
                ? logoShwePuzzleNewYear
                : logoShwePuzzle
          }
        />
        <ActionComponent />
        <Reel />

        {IS_EVENT_NEW_YEAR_2025_THEME ? null : (
          <img
            src={
              IS_EVENT_THADINGYUT_2025_THEME
                ? imgReelFooterThadingyutTheme
                : imgReelFooter
            }
            alt=''
            className='mini-game-img-reel-footer'
          />
        )}

        {/* <img src={imgReelFooter} alt="" className="mini-game-img-reel-footer" /> */}
      </div>
      <div className='mission-container-minigame__body position-relative'>
        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div className='mini-game-img-reel-footer-wrapper'>
            <img
              srcSet={`${imgReelFooterNewYear} 2x`}
              alt=''
              className='mini-game-img-reel-footer'
            />
          </div>
        )}
        {!IS_EVENT_THADINGYUT_2025_THEME && !IS_EVENT_NEW_YEAR_2025_THEME && (
          <img src={bg1} alt='' className='bg-mission-body' />
        )}
        {!IS_EVENT_THADINGYUT_2025_THEME && !IS_EVENT_NEW_YEAR_2025_THEME && (
          <img src={bg2} alt='' className='bg2-mission-body' />
        )}

        <MissionsList title={t("mini_game.homepage.lucky_puzzle_prizes")}>
          <ListPrizes dataAwardList={dataAwardList || []} />
        </MissionsList>

        <MissionsList
          title={t("mini_game.homepage.daily_missions")}
          data={dailyMissions}
        >
          {dailyMissions.map((item, index) => {
            return (
              <Fragment key={`dailay_${item.id}`}>
                <ItemMission data={item} isDaily />
              </Fragment>
            );
          })}
        </MissionsList>

        <div className='mini-game-change-container'>
          <MissionsList title={t("mini_game.standard_missions.change_coins")}>
            <CardChange
              setBid={setBid}
              bid={bid}
              bidTotal={bidTotal}
              handleTurnMini={handleTurnMini}
              userInfo={selectorAccount.userInfo}
              showDataLogin={showDataLogin}
              handleToBuyTurn={handleToBuyTurn}
            />
            {selectorAccount.userInfo && (bidTotal === 0 || bidTotal < bid) ? (
              <ErrorContainer>
                <div className='content-error-mini-change'>
                  {bidTotal === 0
                    ? t("mini_game.standard_missions.no_turns_left")
                    : t("mini_game.standard_missions.number_exceeds")}
                </div>
                <div
                  className='content-error-mini-buy'
                  onClick={handleToBuyTurn}
                >
                  {t("mini_game.standard_missions.buy_more_turns")}
                </div>
              </ErrorContainer>
            ) : null}
          </MissionsList>
        </div>

        <MissionsList
          title={t("mini_game.standard_missions.title")}
          data={missionDetail}
        >
          {standardMissions.map((item, index) => {
            return (
              <Fragment key={`standar_${item.id}`}>
                <ItemMission data={item} />
              </Fragment>
            );
          })}
          {/* <Link
            to={`${PATH.MINI_GAME}/${ID_TAB_MINI_GAME.collectPiece}`}
            className={`view-all-mission ${IS_EVENT_THADINGYUT_2025_THEME ? "thadingyut-theme" : ""
              } ${IS_EVENT_NEW_YEAR_2025_THEME ? "new-year-25-theme" : ""}`}
          >
            {t("mini_game.standard_missions.view_all")}
          </Link> */}
        </MissionsList>

        {IS_EVENT_THADINGYUT_2025_THEME && (
          <LanternIconContainer>
            <img src={lanternIcon} alt='Lantern Icon' />
          </LanternIconContainer>
        )}
        {IS_EVENT_THADINGYUT_2025_THEME && (
          <LotusIconContainer>
            <img src={lotusIcon} alt='Lotus Icon' />
          </LotusIconContainer>
        )}

        {IS_EVENT_NEW_YEAR_2025_THEME && (
          <div
            style={{
              position: "absolute",
              zIndex: 1,
              bottom: 0,
              left: 0,
              right: 0,
              width: "100%",
              pointerEvents: "none",
            }}
          >
            <img
              src={footerTree}
              alt='footer-tree'
              className='footer-tree-new-year-25-theme'
              style={{
                width: "100%",
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}

const ErrorContainer = styled.div`
  background-color: rgb(254, 243, 242);
  padding: 16px;
  border-radius: 12px;

  .content-error-mini-change,
  .content-error-mini-buy {
    font-size: 14px;

    @media (min-width: 768px) {
      font-size: 16px;
    }
  }
`;

const LanternIconContainer = styled.div`
  position: absolute;
  right: 0;
  pointer-events: none;
  z-index: 2;
  transform: rotate(35deg) translate(18%, -30%);
  max-width: 30%;
  top: 0;

  @media (max-width: 1440px) {
    max-width: 35%;
  }

  @media (max-width: 600px) {
    transform: rotate(35deg) translate(30%, -25%);
  }

  @media (max-width: 492px) {
    transform: rotate(35deg) translate(41%, -5%);
  }
`;

const LotusIconContainer = styled.div`
  position: absolute;
  right: 0;
  transform: rotate(335deg) translate(30%, -15%);
  z-index: 0;
  pointer-events: none;

  @media (max-width: 768px) {
    transform: rotate(335deg) translate(40%, -8%);
    img {
      max-width: 85%;
    }
  }
`;
